console.log('Header JS loaded');

const headerNav = document.querySelector('.bds-header__nav');

function toggleHeaderNav() {
    headerNav.classList.toggle('open');
}

document.getElementById('openMobileNav').addEventListener('click', toggleHeaderNav);
document.getElementById('closeMobileNav').addEventListener('click', toggleHeaderNav);